// extracted by mini-css-extract-plugin
module.exports = {"component":"FirstTimeLoginScreen_component__2KX8H"};